import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

const PurchasedLockNotice = ({ isLimited }) => isLimited && (
  <Box sx={{ p: 1.5, mb: 2, backgroundColor: "#fff3cd", borderRadius: 1, border: "1px solid #ffc107" }}>
    <Typography variant="body2" color="warning.dark">
      This ad has been <strong>Purchased</strong>. Position, date range, and scheduling are
      locked. Only Banner Name, Description, Banner Image, and Targeting can be updated.
    </Typography>
  </Box>
);

PurchasedLockNotice.propTypes = {
  isLimited: PropTypes.bool.isRequired,
};

export default PurchasedLockNotice;
